module.exports = __webpack_public_path__ + "img/cloud-off.40587ec4.svg";